import { Counter } from './types'

const warningUsageThreshold = 0.9

export const isNearThreshold = ({ currentValue, threshold }: Counter) =>
  currentValue / threshold >= warningUsageThreshold

export const getCounterStatus = (counter: Counter) => {
  if (!counter.isEnabled) return 'unlimited'
  if (counter.isEnabled && counter.currentValue >= counter.threshold)
    return 'limit_reached'
  if (counter.isEnabled && isNearThreshold(counter)) return 'near_limit'
  return 'ok'
}
